import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';

@Directive({
  selector: '[libPermission]'
})
export class PermissionDirective {
  @Input()
  set libPermission(permissions: string | string[]) {
    if (permissions) {
      this.permissionService.hasPermission(permissions).then((hasPermission: boolean) => {
        if (!hasPermission) {
          this.viewContainerRef.clear();
        } else {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
      }).catch(_ => {
        this.viewContainerRef.clear();
      });
    }
  }

  constructor(private permissionService: NgxPermissionsService,
              private templateRef: TemplateRef<any>,
              private viewContainerRef: ViewContainerRef) {
  }
}
